import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createProduct, productsQueryKeys } from '@api/products';
import type { CreateProductResponse } from '@api/products';

interface UseCreateProductOptions {
  onSuccess?: (response: CreateProductResponse) => void;
}

export function useCreateProduct(options?: UseCreateProductOptions) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createProduct,
    onSuccess: (response) => {
      queryClient.invalidateQueries({ queryKey: productsQueryKeys.lists() });
      options?.onSuccess?.(response);
    },
  });
}
